<nz-header nz-row nzJustify="space-between" nzAlign="middle">

    <!-- * -->
    <div class="flex">
        <div class="header-trigger" id="header-trigger" (click)="onCollapse()">
            <mat-icon title="Menu" nz-icon class="material-icons-outlined"
                      [svgIcon]="isCollapsed ? 'unfold' : 'fold'"></mat-icon>
        </div>

        <div class="sidebar-logo" nz-col [routerLink]="['/dashboard']">
            <div class="logo_cont">
                <img [src]="ptIcon" alt="logo" id="logo_purpletree">
            </div>
            <div class="separator"></div>
            <div class="logo_cont">
                <img [src]="partnerIcon" alt="partnerlogo">
            </div>
        </div>
    </div>

    <!-- * -->

    <xng-breadcrumb nz-col nzFlex="auto" [autoGenerate]="true" class="breadcrumb"
                    [separator]="iconTemplate"></xng-breadcrumb>
    <ng-template #iconTemplate>
        <mat-icon style="font-size: 12px;
        opacity: .6;">arrow_forward_ios
        </mat-icon>
    </ng-template>

    <ul nz-menu nzTheme="dark" nzMode="horizontal" class="header-menu" nz-col nzAlign="middle">
<!--        <li *ngIf="currentUser" nz-button nzTrigger="click" class="ant-menu-item info_container">-->
<!--            <a [routerLink]="['profile']" routerLinkActive="router-link-active"-->
<!--               style="display: flex;align-items: center;">-->
<!--                <pt-avatar [url]="currentUser.avatar" [canEdit]="false"></pt-avatar>-->
<!--                <span class="user-name">{{currentUser.first_name}} {{currentUser.last_name}}</span>-->
<!--            </a>-->
<!--            <span (click)="askLogout()" class="logout_item"> <i nz-col nz-icon nzType="logout"></i></span>-->
<!--        </li>-->
        <li>
            <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu"
               style="display: flex;align-items: center;">
                <nz-avatar nzIcon="user" [nzSrc]="currentUser.avatar" [nzSize]="40" style="background-color: rgba(238,238,238,0.73)"></nz-avatar>
<!--                <pt-avatar [url]="currentUser.avatar" [canEdit]="false"></pt-avatar>-->
            </a>
            <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu class="profile_menu">
                    <li nz-menu-item class="profile_menu_item">
                        <nz-avatar nzIcon="user" [nzSrc]="currentUser.avatar" [nzSize]="65" style="background-color: rgba(238,238,238,0.73)"></nz-avatar>
                        <!--                        <pt-avatar [url]="currentUser.avatar" [canEdit]="false"></pt-avatar>-->
                        <div class="profile_details">
                            <span class="user-name">{{currentUser.first_name}} {{currentUser.last_name}}</span>
                            <span class="ruolo">{{currentUser.roles.join(', ')}}</span>
                        </div>

                    </li>
                    <li nz-menu-item class="profile_menu_item" (click)="profile()">Profilo</li>
                    <li nz-menu-item class="profile_menu_item" (click)="logout()">
                        <span  class="logout_item">Logout</span>
                        <span nz-icon nzType="poweroff" nzTheme="outline"></span>
                    </li>
                </ul>
            </nz-dropdown-menu>
        </li>
    </ul>


</nz-header>
